﻿/**
* DevExpress Analytics (widgets\criteria\parser\criteriaparser.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var criteriaCreator = require('../criteriaOperatorPreprocessor').criteriaCreator;
var BinaryOperatorType = require('../operators/binary').BinaryOperatorType;
var UnaryOperatorType = require('../operators/unary').UnaryOperatorType;
var group = require('../operators/group');
var GroupOperatorType = group.GroupOperatorType;
var GroupOperator = group.GroupOperator;
var FunctionOperatorType = require('../operators/function').FunctionOperatorType;
var JoinOperand = require('../operators/join').JoinOperand;
var Aggregate = require('../operators/aggregate').Aggregate;
/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var criteriaparser = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,7],$V1=[1,6],$V2=[1,30],$V3=[1,8],$V4=[1,9],$V5=[1,10],$V6=[1,11],$V7=[1,25],$V8=[1,12],$V9=[1,13],$Va=[1,14],$Vb=[1,15],$Vc=[1,16],$Vd=[1,17],$Ve=[1,18],$Vf=[1,19],$Vg=[1,20],$Vh=[1,21],$Vi=[1,22],$Vj=[1,23],$Vk=[1,24],$Vl=[1,27],$Vm=[1,29],$Vn=[1,28],$Vo=[1,32],$Vp=[1,33],$Vq=[1,34],$Vr=[1,35],$Vs=[1,36],$Vt=[1,37],$Vu=[1,38],$Vv=[1,39],$Vw=[1,40],$Vx=[1,41],$Vy=[1,42],$Vz=[1,43],$VA=[1,44],$VB=[1,45],$VC=[1,46],$VD=[1,47],$VE=[1,48],$VF=[1,49],$VG=[1,50],$VH=[1,51],$VI=[1,52],$VJ=[5,9,10,11,12,13,14,15,16,19,20,21,22,23,24,25,26,27,28,30,31,33,35,36,52],$VK=[5,9,10,11,12,13,14,15,16,19,20,21,22,23,24,25,26,27,28,30,31,33,35,36,51,52,53,55,56,57],$VL=[1,60],$VM=[5,14,15,16,19,20,21,22,23,24,25,26,27,28,30,31,33,35,36,52],$VN=[5,27,28,30,36,52],$VO=[1,111],$VP=[1,112],$VQ=[1,106],$VR=[1,108],$VS=[1,109],$VT=[1,107],$VU=[1,110],$VV=[5,11,12,14,15,16,19,20,21,22,23,24,25,26,27,28,30,31,33,35,36,52],$VW=[5,19,20,25,26,27,28,30,31,36,52],$VX=[5,19,20,21,22,23,24,25,26,27,28,30,31,36,52],$VY=[30,36];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"expressions":3,"exp":4,"EOF":5,"const":6,"propertyWithAgg":7,"parameter":8,"*":9,"/":10,"+":11,"-":12,"%":13,"|":14,"&":15,"^":16,"!":17,"~":18,"OP_EQ":19,"OP_NE":20,"OP_GT":21,"OP_LT":22,"OP_GE":23,"OP_LE":24,"OP_LIKE":25,"NOT":26,"AND":27,"OR":28,"(":29,")":30,"IS":31,"NULL":32,"OP_IN":33,"arguments":34,"OP_BETWEEN":35,",":36,"NAME_SOFT":37,"AGG_MIN":38,"AGG_MAX":39,"AGG_COUNT":40,"AGG_AVG":41,"AGG_SUM":42,"AGG_EXISTS":43,"AGG_SINGLE":44,"STRING":45,"NUMBER":46,"OBJECT":47,"BOOLEAN":48,"GUID":49,"property":50,"[":51,"]":52,".":53,"agg":54,"FIELD_END":55,"CH":56,"ESC_CH":57,"FIELD_START":58,"?":59,"commaseparated":60,"$accept":0,"$end":1},
terminals_: {2:"error",5:"EOF",9:"*",10:"/",11:"+",12:"-",13:"%",14:"|",15:"&",16:"^",17:"!",18:"~",19:"OP_EQ",20:"OP_NE",21:"OP_GT",22:"OP_LT",23:"OP_GE",24:"OP_LE",25:"OP_LIKE",26:"NOT",27:"AND",28:"OR",29:"(",30:")",31:"IS",32:"NULL",33:"OP_IN",35:"OP_BETWEEN",36:",",37:"NAME_SOFT",38:"AGG_MIN",39:"AGG_MAX",40:"AGG_COUNT",41:"AGG_AVG",42:"AGG_SUM",43:"AGG_EXISTS",44:"AGG_SINGLE",45:"STRING",46:"NUMBER",47:"OBJECT",48:"BOOLEAN",49:"GUID",51:"[",52:"]",53:".",55:"FIELD_END",56:"CH",57:"ESC_CH",58:"FIELD_START",59:"?"},
productions_: [0,[3,2],[4,1],[4,1],[4,1],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,2],[4,2],[4,2],[4,2],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,3],[4,4],[4,2],[4,3],[4,3],[4,3],[4,3],[4,4],[4,3],[4,7],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[4,2],[6,1],[6,1],[6,1],[6,1],[6,1],[6,1],[7,6],[7,5],[7,3],[7,4],[7,3],[7,1],[7,4],[54,3],[54,1],[54,3],[54,1],[54,4],[54,4],[54,3],[54,4],[54,4],[54,4],[50,2],[50,2],[50,2],[50,3],[50,3],[50,1],[50,1],[50,1],[8,2],[8,1],[34,2],[34,3],[60,1],[60,3]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1:
 return $$[$0-1]; 
break;
case 2:
 this.$ = criteriaCreator.process("const", { value: $$[$0] }); 
break;
case 3: case 4: case 41: case 42: case 43: case 44: case 45:
 this.$ = $$[$0]; 
break;
case 5:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Multiply }); 
break;
case 6:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Divide }); 
break;
case 7:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Plus }); 
break;
case 8:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Minus }); 
break;
case 9:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Modulo }); 
break;
case 10:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.BitwiseOr }); 
break;
case 11:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.BitwiseAnd }); 
break;
case 12:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.BitwiseXor }); 
break;
case 13:
 this.$ = criteriaCreator.process("unary", { operatorType: UnaryOperatorType.Minus, operator: $$[$0] }); 
break;
case 14:
 this.$ = criteriaCreator.process("unary", { operatorType: UnaryOperatorType.Plus, operator: $$[$0] }); 
break;
case 15: case 25:
 this.$ = criteriaCreator.process("unary", { operatorType: UnaryOperatorType.Not, operator: $$[$0] }); 
break;
case 16:
 this.$ = criteriaCreator.process("unary", { operatorType: UnaryOperatorType.BitwiseNot, operator: $$[$0] }); 
break;
case 17:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Equal }); 
break;
case 18:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.NotEqual }); 
break;
case 19:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Greater }); 
break;
case 20:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Less }); 
break;
case 21:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.GreaterOrEqual }); 
break;
case 22:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.LessOrEqual }); 
break;
case 23:
 this.$ = criteriaCreator.process("binary",  { left: $$[$0-2], right: $$[$0], operatorType: BinaryOperatorType.Like }); 
break;
case 24:

            this.$ = criteriaCreator.process("unary", { 
                operatorType: UnaryOperatorType.Not, 
                operator: criteriaCreator.process("binary", { left: $$[$0-3], right: $$[$0], operatorType: BinaryOperatorType.Like }) 
            });
        
break;
case 26:
 this.$ = GroupOperator.combine(GroupOperatorType.And, [$$[$0-2], $$[$0]]); 
break;
case 27:
 this.$ = GroupOperator.combine(GroupOperatorType.Or, [$$[$0-2], $$[$0]]); 
break;
case 28: case 64: case 75:
 this.$ = $$[$0-1]; 
break;
case 29:
 this.$ = criteriaCreator.process("unary", { operatorType: UnaryOperatorType.IsNull, operator: $$[$0-2] }); 
break;
case 30:
 
            this.$ = criteriaCreator.process("unary", { 
                operatorType: UnaryOperatorType.Not,
                operator: criteriaCreator.process("unary", { operatorType: UnaryOperatorType.IsNull, operator: $$[$0-3] })
            }); 
        
break;
case 31:
 this.$ = criteriaCreator.process("in", { criteriaOperator: $$[$0-2], operands: $$[$0] }); 
break;
case 32:
 this.$ = criteriaCreator.process("between", { property: $$[$0-6], begin: $$[$0-3], end: $$[$0-1] }); 
break;
case 33:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType[$$[$0-1]] || $$[$0-1], operands: $$[$0] }); 
break;
case 34:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType.Min, operands: $$[$0] }); 
break;
case 35:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType.Max, operands: $$[$0] }); 
break;
case 36:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType["Count"] || "Count", operands: $$[$0] }); 
break;
case 37:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType["Avg"] || "Avg", operands: $$[$0] }); 
break;
case 38:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType["Sum"] || "Sum", operands: $$[$0] }); 
break;
case 39:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType["Exists"] || "Exists", operands: $$[$0] }); 
break;
case 40:
 this.$ = criteriaCreator.process("function", { operatorType: FunctionOperatorType["Single"] || "Single", operands: $$[$0] }); 
break;
case 46:
 this.$ = null; 
break;
case 47:
 
            this.$ = JoinOperand.joinOrAggregate(
                criteriaCreator.process("property", { propertyName: $$[$0-5].name, startColumn: $$[$0-5].col, circumflex: $$[$0-5].circumflex, startLine: $$[$0-5].line, originalPropertyLength: _$[$0-5].last_column - _$[$0-5].first_column + 1 }), 
                $$[$0-3], $$[$0].type, $$[$0].expr
            );
        
break;
case 48:
 
            this.$ = JoinOperand.joinOrAggregate(
                criteriaCreator.process("property", { propertyName: $$[$0-4].name, startColumn: $$[$0-4].col, circumflex: $$[$0-4].circumflex, startLine: $$[$0-4].line, originalPropertyLength: _$[$0-4].last_column - _$[$0-4].first_column + 1 }), 
                null, $$[$0].type, $$[$0].expr
            );
        
break;
case 49:
 
            this.$ = JoinOperand.joinOrAggregate(
                criteriaCreator.process("property", { propertyName: $$[$0-2].name, startColumn: $$[$0-2].col, circumflex: $$[$0-2].circumflex, startLine: $$[$0-2].line, originalPropertyLength: _$[$0-2].last_column - _$[$0-2].first_column }), 
                null, $$[$0].type, $$[$0].expr
            );
        
break;
case 50:
 
            this.$ = JoinOperand.joinOrAggregate(
                criteriaCreator.process("property", { propertyName: $$[$0-3].name, startColumn: $$[$0-3].col, circumflex: $$[$0-3].circumflex, startLine: $$[$0-3].line, originalPropertyLength: _$[$0-3].last_column - _$[$0-3].first_column + 1 }), 
                $$[$0-1], Aggregate.Exists, null
            );
        
break;
case 51:
 
            this.$ = JoinOperand.joinOrAggregate(
                criteriaCreator.process("property", { propertyName: $$[$0-2].name, startColumn: $$[$0-2].col, circumflex: $$[$0-2].circumflex, startLine: $$[$0-2].line, originalPropertyLength: _$[$0-2].last_column - _$[$0-2].first_column + 1 }), 
                null, Aggregate.Exists, null);
        
break;
case 52:
 
            this.$ = criteriaCreator.process("property", { propertyName: $$[$0].name, startColumn: $$[$0].col, circumflex: $$[$0].circumflex, startLine: $$[$0].line, originalPropertyLength: _$[$0].last_column - _$[$0].first_column });
        
break;
case 53:
 
            this.$ = JoinOperand.joinOrAggregate(
                criteriaCreator.process("property", { }), 
                null, $$[$0].type, $$[$0].expr
            ); 
        
break;
case 54:
 this.$ = { type:  Aggregate.Count  };  
break;
case 55:
 this.$ = { type:  Aggregate.Count };   
break;
case 56: case 57:
 this.$ = { type:  Aggregate.Exists }; 
break;
case 58:
 this.$ = { type:  Aggregate.Avg, expr: $$[$0-1] }; 
break;
case 59:
 this.$ = { type:  Aggregate.Sum, expr: $$[$0-1] }; 
break;
case 60:
 this.$ = { type:  Aggregate.Single, expr: criteriaCreator.process("property", { propertyName: "This" }) }; 
break;
case 61:
 this.$ = { type:  Aggregate.Single, expr: $$[$0-1] }; 
break;
case 62:
 this.$ = { type:  Aggregate.Min, expr: $$[$0-1] }; 
break;
case 63:
 this.$ = { type:  Aggregate.Max, expr: $$[$0-1] }; 
break;
case 65:
 this.$ = { name: $$[$0-1].name + $$[$0], line: $$[$0-1].line, circumflex: $$[$0-1].circumflex, col: $$[$0-1].col }; 
break;
case 66:
 this.$ = { name: $$[$0-1].name + $$[$0].substr(1), line: $$[$0-1].line, circumflex: $$[$0-1].circumflex, col: $$[$0-1].col }; 
break;
case 67:
 
        if($$[$0-2].circumflex && $$[$0-2].started) {
            this.$ = { name: '', line: $$[$0-2].line, circumflex: $$[$0-2].circumflex, col: $$[$0-2].col + 2 }; 
        } else 
            this.$ = { name: $$[$0-2].name + '.', line: $$[$0-2].line, circumflex: $$[$0-2].circumflex, col: $$[$0-2].col }; 
    
break;
case 68:
 
        if($$[$0-2].circumflex && $$[$0-2].started){ 
            this.$ = { name: $$[$0], line: $$[$0-2].line, circumflex: $$[$0-2].circumflex, col: $$[$0-2].col + 1 }; 
        } else 
            this.$ = { name: $$[$0-2].name + '.' + $$[$0], line: $$[$0-2].line, circumflex: $$[$0-2].circumflex, col: $$[$0-2].col }; 
    
break;
case 69:
 this.$ = { name: "", line: _$[$0].first_line - 1, col: _$[$0].first_column + 1 }; 
break;
case 70:
 this.$ = { name: $$[$0], line: _$[$0].first_line - 1, col: _$[$0].first_column }; 
break;
case 71:
 this.$ = { circumflex: true, started: true, name: "", line: _$[$0].first_line - 1, col: _$[$0].first_column + 1 }; 
break;
case 72:
 this.$ = criteriaCreator.process("parameter", { parameterName: $$[$0] }); 
break;
case 73:
 this.$ = criteriaCreator.process("value", { }); 
break;
case 74:
 this.$ = []; 
break;
case 76:
 this.$ = [$$[$0]]; 
break;
case 77:
 this.$ = $$[$0-2].concat($$[$0]); 
break;
}
},
table: [{3:1,4:2,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{1:[3]},{5:[1,31],9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,31:$VG,33:$VH,35:$VI},o($VJ,[2,2]),o($VJ,[2,3]),o($VJ,[2,4]),{4:53,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:54,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:55,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:56,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:57,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:58,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},o($VK,[2,70],{34:59,29:$VL}),{29:$VL,34:61},{29:$VL,34:62},{29:$VL,34:63},{29:$VL,34:64},{29:$VL,34:65},{29:$VL,34:66},{29:$VL,34:67},o($VJ,[2,41]),o($VJ,[2,42]),o($VJ,[2,43]),o($VJ,[2,44]),o($VJ,[2,45]),o($VJ,[2,46]),o($VJ,[2,52],{51:[1,68],53:[1,69],55:[1,70],56:[1,71],57:[1,72]}),{52:[1,73]},o($VJ,[2,73],{37:[1,74]}),o($VK,[2,69]),o($VK,[2,71]),{1:[2,1]},{4:75,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:76,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:77,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:78,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:79,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:80,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:81,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:82,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:83,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:84,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:85,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:86,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:87,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:88,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:89,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{25:[1,90]},{4:91,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:92,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{26:[1,94],32:[1,93]},{29:$VL,34:95},{29:[1,96]},o($VJ,[2,13]),o($VJ,[2,14]),o($VJ,[2,15]),o($VM,[2,16],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs}),o($VN,[2,25],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,31:$VG,33:$VH,35:$VI}),{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,30:[1,97],31:$VG,33:$VH,35:$VI},o($VJ,[2,33]),{4:100,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,30:[1,98],32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn,60:99},o($VJ,[2,34]),o($VJ,[2,35]),o($VJ,[2,36]),o($VJ,[2,37]),o($VJ,[2,38]),o($VJ,[2,39]),o($VJ,[2,40]),{4:101,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,52:[1,102],58:$Vm,59:$Vn},{37:[1,105],38:$VO,39:$VP,40:$VQ,41:$VR,42:$VS,43:$VT,44:$VU,54:103,58:[1,104]},o($VK,[2,64]),o($VK,[2,65]),o($VK,[2,66]),{53:[1,113]},o($VJ,[2,72]),o($VJ,[2,5]),o($VJ,[2,6]),o($VV,[2,7],{9:$Vo,10:$Vp,13:$Vs}),o($VV,[2,8],{9:$Vo,10:$Vp,13:$Vs}),o($VJ,[2,9]),o([5,14,19,20,21,22,23,24,25,26,27,28,30,31,33,35,36,52],[2,10],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,15:$Vu,16:$Vv}),o($VM,[2,11],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs}),o([5,14,16,19,20,21,22,23,24,25,26,27,28,30,31,33,35,36,52],[2,12],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,15:$Vu}),o($VW,[2,17],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,21:$Vy,22:$Vz,23:$VA,24:$VB,33:$VH,35:$VI}),o($VW,[2,18],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,21:$Vy,22:$Vz,23:$VA,24:$VB,33:$VH,35:$VI}),o($VX,[2,19],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,33:$VH,35:$VI}),o($VX,[2,20],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,33:$VH,35:$VI}),o($VX,[2,21],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,33:$VH,35:$VI}),o($VX,[2,22],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,33:$VH,35:$VI}),o($VW,[2,23],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,21:$Vy,22:$Vz,23:$VA,24:$VB,33:$VH,35:$VI}),{4:114,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},o($VN,[2,26],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,31:$VG,33:$VH,35:$VI}),o([5,28,30,36,52],[2,27],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,31:$VG,33:$VH,35:$VI}),o($VJ,[2,29]),{32:[1,115]},o($VJ,[2,31]),{4:116,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},o($VJ,[2,28]),o($VJ,[2,74]),{30:[1,117],36:[1,118]},o($VY,[2,76],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,31:$VG,33:$VH,35:$VI}),{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,31:$VG,33:$VH,35:$VI,52:[1,119]},o($VJ,[2,51],{53:[1,120]}),o($VJ,[2,49]),o($VK,[2,67]),o($VK,[2,68]),o($VJ,[2,55],{29:[1,121]}),o($VJ,[2,57],{29:[1,122]}),{29:[1,123]},{29:[1,124]},{29:[1,125]},{29:[1,126]},{29:[1,127]},{38:$VO,39:$VP,40:$VQ,41:$VR,42:$VS,43:$VT,44:$VU,54:128},o($VW,[2,24],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,21:$Vy,22:$Vz,23:$VA,24:$VB,33:$VH,35:$VI}),o($VJ,[2,30]),{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,31:$VG,33:$VH,35:$VI,36:[1,129]},o($VJ,[2,75]),{4:130,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},o($VJ,[2,50],{53:[1,131]}),{38:$VO,39:$VP,40:$VQ,41:$VR,42:$VS,43:$VT,44:$VU,54:132},{30:[1,133]},{30:[1,134]},{4:135,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:136,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:138,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,30:[1,137],32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:139,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},{4:140,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},o($VJ,[2,53]),{4:141,6:3,7:4,8:5,11:$V0,12:$V1,16:$V2,17:$V3,18:$V4,26:$V5,29:$V6,32:$V7,37:$V8,38:$V9,39:$Va,40:$Vb,41:$Vc,42:$Vd,43:$Ve,44:$Vf,45:$Vg,46:$Vh,47:$Vi,48:$Vj,49:$Vk,50:26,51:$Vl,58:$Vm,59:$Vn},o($VY,[2,77],{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,31:$VG,33:$VH,35:$VI}),{38:$VO,39:$VP,40:$VQ,41:$VR,42:$VS,43:$VT,44:$VU,54:142},o($VJ,[2,48]),o($VJ,[2,54]),o($VJ,[2,56]),{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,30:[1,143],31:$VG,33:$VH,35:$VI},{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,30:[1,144],31:$VG,33:$VH,35:$VI},o($VJ,[2,60]),{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,30:[1,145],31:$VG,33:$VH,35:$VI},{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,30:[1,146],31:$VG,33:$VH,35:$VI},{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,30:[1,147],31:$VG,33:$VH,35:$VI},{9:$Vo,10:$Vp,11:$Vq,12:$Vr,13:$Vs,14:$Vt,15:$Vu,16:$Vv,19:$Vw,20:$Vx,21:$Vy,22:$Vz,23:$VA,24:$VB,25:$VC,26:$VD,27:$VE,28:$VF,30:[1,148],31:$VG,33:$VH,35:$VI},o($VJ,[2,47]),o($VJ,[2,58]),o($VJ,[2,59]),o($VJ,[2,61]),o($VJ,[2,62]),o($VJ,[2,63]),o($VJ,[2,32])],
defaultActions: {31:[2,1]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0: this.begin('INITIAL'); return 51; 
break;
case 1: this.begin('INITIAL'); return 55; 
break;
case 2:return 57;
break;
case 3:return 56;
break;
case 4:return 'INVALID';
break;
case 5:return 45
break;
case 6:return 49
break;
case 7:return 47
break;
case 8:return 46
break;
case 9:return 48
break;
case 10:return 48
break;
case 11:/* skip whitespace */
break;
case 12:return 35
break;
case 13:return 33
break;
case 14:return 26
break;
case 15:return 31
break;
case 16:return 32
break;
case 17:return 9
break;
case 18:return 10
break;
case 19:return 12
break;
case 20:return 11
break;
case 21:return 16
break;
case 22:return 18
break;
case 23:return 20
break;
case 24:return 17
break;
case 25:return 13
break;
case 26:return 20
break;
case 27:return 23
break;
case 28:return 24
break;
case 29:return 21
break;
case 30:return 22
break;
case 31:return 28
break;
case 32:return 27
break;
case 33:return 41
break;
case 34:return 39
break;
case 35:return 38
break;
case 36:return 44
break;
case 37:return 40
break;
case 38:return 43
break;
case 39:return 42
break;
case 40:return 19
break;
case 41:return 19
break;
case 42:return 25
break;
case 43:return 27
break;
case 44:return 28
break;
case 45:return 15
break;
case 46:return 14
break;
case 47: this.begin('fieldname'); return 58; 
break;
case 48:return 52;
break;
case 49:return 29
break;
case 50:return 30
break;
case 51:return 53
break;
case 52:return 36
break;
case 53:return 59
break;
case 54:return 37
break;
case 55:return 'INVALID'
break;
case 56:return 5
break;
}
},
rules: [/^(?:\]\s*\[)/i,/^(?:\])/i,/^(?:\\.)/i,/^(?:.)/i,/^(?:$)/i,/^(?:'(?:[^\']|(?:('')))*')/i,/^(?:\{[0-9A-Fa-f]{8}[-]?(?:[0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}\})/i,/^(?:#(?:[^\\\#]|(?:\\.))*#)/i,/^(?:[0-9]+(\.[0-9]+([mfMF]{1})?|[bsiluBSILU]{1})?)/i,/^(?:True\b)/i,/^(?:False\b)/i,/^(?:\s+)/i,/^(?:Between\b)/i,/^(?:In\b)/i,/^(?:Not\b)/i,/^(?:Is\b)/i,/^(?:Null\b)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:-)/i,/^(?:\+)/i,/^(?:\^)/i,/^(?:~)/i,/^(?:!=)/i,/^(?:!)/i,/^(?:%)/i,/^(?:<>)/i,/^(?:>=)/i,/^(?:<=)/i,/^(?:>)/i,/^(?:<)/i,/^(?:\|\|)/i,/^(?:&&)/i,/^(?:Avg\b)/i,/^(?:Max\b)/i,/^(?:Min\b)/i,/^(?:Single\b)/i,/^(?:Count\b)/i,/^(?:Exists\b)/i,/^(?:Sum\b)/i,/^(?:==)/i,/^(?:=)/i,/^(?:Like\b)/i,/^(?:And\b)/i,/^(?:Or\b)/i,/^(?:&)/i,/^(?:\|)/i,/^(?:\[)/i,/^(?:\])/i,/^(?:\()/i,/^(?:\))/i,/^(?:\.)/i,/^(?:,)/i,/^(?:\?)/i,/^(?:[_\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376-\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E-\u066F\u0671-\u06D3\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4-\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0-\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0-\u0CE1\u0CF1-\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E46\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065-\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE-\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5-\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183-\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3006\u3031-\u3035\u303B-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC][\d_\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376-\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E-\u066F\u0671-\u06D3\u06D5\u06E5-\u06E6\u06EE-\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4-\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0-\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0-\u0CE1\u0CF1-\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E46\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065-\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE-\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5-\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183-\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3006\u3031-\u3035\u303B-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40-\uFB41\uFB43-\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*)/i,/^(?:.)/i,/^(?:$)/i],
conditions: {"fieldname":{"rules":[0,1,2,3,4],"inclusive":false},"INITIAL":{"rules":[5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();
exports.criteriaparser = criteriaparser;
exports.parse = function(test) { return criteriaparser.parse(test) };
